import { render, staticRenderFns } from "./instance-watchers.vue?vue&type=template&id=aa45beee&"
import script from "./instance-watchers.vue?vue&type=script&lang=js&"
export * from "./instance-watchers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports